const config = {
  API_BASE_URL: "/api",
  ORIGIN: `https://cors-anywhere.herokuapp.com/https://${process.env.REACT_APP_API_SUBDOMAIN}.alertrules.com`,
  ERUDA: true
};

export default config;